export default __webpack_public_path__ + "static/media/stall.5707217b.png";